import * as d3 from 'd3';
import * as _ from 'lodash';

import { CategoricalChartData } from './CategoricalChart.model';

export function getDataExtent(data: CategoricalChartData[]): number[] {
    let dataExtent: number[];
    if (data && data.length > 0) {
        dataExtent = d3.extent(data, d => d.value);

        // take the bounds for the y-scale from data OR the min-max if they're displayed
        const flatten = flattenData(data);

        const seriesMinMax = d3.extent(flatten)
            .filter(s => s !== undefined);

        if (seriesMinMax && seriesMinMax.length > 0) {
            dataExtent[0] = Math.min(dataExtent[0], seriesMinMax[0]);
            // if only one number in the seriesMinMax extent, use that one
            const idx = (seriesMinMax.length === 1) ? 0 : 1;
            dataExtent[1] = Math.max(dataExtent[1], seriesMinMax[idx]);
        }
        if (dataExtent[0] === undefined && dataExtent[1] === undefined) {
            dataExtent = [0, 1];
        }
    } else {
        dataExtent = [0, 1];
    }
    return dataExtent;
}

function flattenData(data: CategoricalChartData[]) {
    return data
        ? _.flatten<number>(data.map(s => {
            const ret: number[] = [];
            if (s.hasMax) {
                ret.push(s.max);
            }
            if (s.hasMin) {
                ret.push(s.min);
            }
            return ret;
        }))
        : [];
}
